import { render } from "./ProductAttributeButtonGrid.vue?vue&type=template&id=6caf83c2&scoped=true"
import script from "./ProductAttributeButtonGrid.vue?vue&type=script&lang=js"
export * from "./ProductAttributeButtonGrid.vue?vue&type=script&lang=js"

import "./ProductAttributeButtonGrid.vue?vue&type=style&index=0&id=6caf83c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6caf83c2"]])

export default __exports__